import onloadData from "../activeProjectsService/onload.json";

export const VendorOnboardingDropdownExamples: any = {
  vendorPrePanelComponent: {
    categoryList: [
      { id: "1", category: "CATEGORY 1" },
      { id: "2", category: "CATEGORY 2" },
      { id: "3", category: "CATEGORY 3" }
    ],
    developerList: [
      { id: "100", developer: "Jessie Lee" },
      { id: "101", developer: "Alex Kim" },
      { id: "102", developer: "Jordan Smith" }
    ],
    categoryManagerList: [
      { id: "4", categoryManager: "CATEGORY MANAGER 1" },
      { id: "5", categoryManager: "CATEGORY MANAGER 2" },
      { id: "6", categoryManager: "CATEGORY MANAGER 3" }
    ],
    productTypeList: [
      { id: "7", productType: "PRODUCT TYPE 1" },
      { id: "8", productType: "PRODUCT TYPE 2" },
      { id: "9", productType: "PRODUCT TYPE 3" }
    ],
    sellingPeriodList: [
      { id: "10", sellingPeriod: "SELLING PERIOD 1" },
      { id: "11", sellingPeriod: "SELLING PERIOD 2" },
      { id: "12", sellingPeriod: "SELLING PERIOD 3" }
    ],
    requiredAttributesList: [
      { id: "201", value: "Organic" },
      { id: "202", value: "Gluten Free" },
      { id: "203", value: "Vegan" }
    ]
  },

  vendorSiteDetailsComponent: {
    cityList: [
      { id: "25", city: "CITY 1" },
      { id: "26", city: "CITY 2" },
      { id: "27", city: "CITY 3" }
    ],
    stateList: [
      { id: "28", state: "STATE/REGION 1" },
      { id: "29", state: "STATE/REGION 2" },
      { id: "30", state: "STATE/REGION 3" }
    ],
    countryList: onloadData.country || [
      { id: "31", country: "COUNTRY 1" },
      { id: "32", country: "COUNTRY 2" },
      { id: "33", country: "COUNTRY 3" }
    ],
    typeList: [
      { id: "34", type: "TYPE 1" },
      { id: "35", type: "TYPE 2" },
      { id: "36", type: "TYPE 3" }
    ],
    businessCategoriesList: [
      { id: "37", category: "CATEGORY 1" },
      { id: "38", category: "CATEGORY 2" },
      { id: "39", category: "CATEGORY 3" }
    ],
    statusList: [
      { id: "40", status: "STATUS 1" },
      { id: "41", status: "STATUS 2" },
      { id: "42", status: "STATUS 3" }
    ],
    gfsiCertifiedList: [
      { id: "43", value: "YES" },
      { id: "44", value: "NO" }
    ],
    organicCertifiedList: [
      { id: "45", value: "YES" },
      { id: "46", value: "NO" }
    ], 
    vendorContactList: [
      { id: "47", value: "CONTACT 1" },
      { id: "48", value: "CONTACT 2" },
      { id: "49", value: "CONTACT 3" }
    ]
  }
};